module.exports = __webpack_public_path__ + "img/yangan.9e1fe646.jpg";